import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const InStoreIcon = ({
  className,
  color,
  containerColor,
  containerSize,
  onClick,
  round,
  size,
}) => (
  <WithIconRounded
    className={className}
    containerColor={containerColor}
    containerSize={containerSize}
    onClick={onClick}
    round={round}
  >
    <svg width={size} height={size} viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.41667 0.918396H12.5833C12.7127 0.918396 12.8403 0.950434 12.956 1.01197C13.0717 1.07351 13.1724 1.16286 13.25 1.27295L15.5 4.4639V17.7596C15.5 17.9946 15.4122 18.2201 15.2559 18.3863C15.0996 18.5525 14.8877 18.6459 14.6667 18.6459H1.33333C1.11232 18.6459 0.900358 18.5525 0.744078 18.3863C0.587797 18.2201 0.5 17.9946 0.5 17.7596V4.4639L2.75 1.27295C2.82762 1.16286 2.92828 1.07351 3.04399 1.01197C3.1597 0.950434 3.2873 0.918396 3.41667 0.918396ZM13.8333 6.23666H2.16667V16.8732H13.8333V6.23666ZM13.4167 4.4639L12.1667 2.69115H3.83333L2.58333 4.4639H13.4167ZM5.5 8.00941V9.78216C5.5 10.4874 5.76339 11.1638 6.23223 11.6625C6.70107 12.1611 7.33696 12.4413 8 12.4413C8.66304 12.4413 9.29893 12.1611 9.76777 11.6625C10.2366 11.1638 10.5 10.4874 10.5 9.78216V8.00941H12.1667V9.78216C12.1667 10.9576 11.7277 12.0848 10.9463 12.916C10.1649 13.7471 9.10507 14.214 8 14.214C6.89493 14.214 5.83512 13.7471 5.05372 12.916C4.27232 12.0848 3.83333 10.9576 3.83333 9.78216V8.00941H5.5Z" fill={color} />
    </svg>

  </WithIconRounded>
);

InStoreIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

InStoreIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#949BA8',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 16,
};

export default InStoreIcon;
